import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  HostListener,
  OnInit,
  DoCheck,
} from '@angular/core';

type HelpTextPropsInterface = {
  [key: string]: string | number;
};

@Directive({
  selector: '[ascCharacterLimit]',
})
export class CharacterLimitDirective implements OnInit, DoCheck {
  @Input() helpTextProps: HelpTextPropsInterface | undefined | null = {};

  @Input('ascCharacterLimit') set ascCharacterLimit(
    value: number | string | undefined | null
  ) {
    if (value === undefined || value === null) {
      value = this._maxLength;
    }
    const numericValue = +value;
    if (!isNaN(numericValue)) {
      this._maxLength = numericValue;
      if (this.span) {
        this.setMaxLengthAttribute();
        this.updateCharacterLimit();
      }
    } else {
      this.removeCharacterLimitSpan();
    }
  }

  private _maxLength: number = 1000;
  private span: HTMLSpanElement | any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngDoCheck(): void {
    this.limitTextareaValue();
    this.updateCharacterLimit();
  }

  ngOnInit(): void {
    this.setMaxLengthAttribute();
    this.createCharacterLimitSpan();
    this.updateCharacterLimit();
  }

  @HostListener('input') onInput(): void {
    this.limitTextareaValue();
    this.updateCharacterLimit();
  }

  private setMaxLengthAttribute(): void {
    this.renderer.setAttribute(
      this.el.nativeElement,
      'maxlength',
      this._maxLength.toString()
    );
  }

  private createCharacterLimitSpan(): void {
    if (this._maxLength) {
      this.span = this.renderer.createElement('span');
      const defaultProp: HelpTextPropsInterface = {
        color: '#3b3b3b',
        float: 'right',
        'font-size': '0.8rem',
        'font-weight': 450,
        ...this.helpTextProps,
      };
      Object.entries(defaultProp).forEach(([property, value]) => {
        this.renderer.setStyle(this.span, property, value);
      });
      this.renderer.appendChild(this.el.nativeElement.parentElement, this.span);
    }
  }

  private removeCharacterLimitSpan(): void {
    if (this.span && this.span.parentElement) {
      this.renderer.removeChild(this.span.parentElement, this.span);
      this.span = null;
    }
  }

  private limitTextareaValue(): void {
    const currentValue: string = this.el.nativeElement.value;
    if (currentValue?.length > this._maxLength) {
      this.el.nativeElement.value = currentValue.slice(0, this._maxLength);
    }
  }

  private updateCharacterLimit(): void {
    if (this.span) {
      this.span.innerText = `${this.el.nativeElement?.value?.length}/${this._maxLength}`;
    }
  }
}
